import { render, staticRenderFns } from "./dishCheck.vue?vue&type=template&id=9e05ded0&scoped=true&"
import script from "./dishCheck.vue?vue&type=script&lang=js&"
export * from "./dishCheck.vue?vue&type=script&lang=js&"
import style0 from "./dishCheck.vue?vue&type=style&index=0&id=9e05ded0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e05ded0",
  null
  
)

export default component.exports